import CustomModal from '@/components/CustomModal';
import { DISTRIBUTION_MAP } from '../const';
import { renderFloat } from '@/utils/fn';
import styles from '../index.less';

export default function HistoryCashDistributionModal({
  visible,
  onClose,
  cashDistribution,
  title,
}) {
  return (
    <CustomModal visible={visible} okCallback={onClose} title={title}>
      <div className={styles.historyCashModal}>
        <p className={styles.historyCashDesc}>
          *网心云收益自2024年11月起，转为云豆发放，此处展示您账号下历史的现金收益
        </p>
        {cashDistribution?.length > 0 && (
          <ul className={styles.historyCashDistList}>
            {cashDistribution.map((item, idx) => (
              <li className={styles.distItem} key={idx}>
                <div className={styles.itemLeft}>
                  <i className={`${styles.icon} ${styles[DISTRIBUTION_MAP[item.is].ename]}`} />
                  <span className={styles.itemName}>{DISTRIBUTION_MAP[item.is].name}</span>
                </div>
                <div className={styles.itemRight}>
                  <span className={styles.amount}>{renderFloat(item.c)}元</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </CustomModal>
  );
}
